import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./Footer.css";

const socialLinks = [
  {
    href: "https://www.linkedin.com/company/fxisai/mycompany",
    src: "/images/SocialmediaIcons/LinkedIn 2.webp",
    alt: "LinkedIn",
    animation: "fadeInDown",
  },
  {
    href: "https://www.instagram.com/fxis.ai/",
    src: "/images/SocialmediaIcons/Instagram 2.svg",
    alt: "Instagram",
    animation: "fadeInUp",
  },
  {
    href: "https://www.facebook.com/fx.data.labs/",
    src: "/images/SocialmediaIcons/Facebook 2.webp",
    alt: "Facebook",
    animation: "fadeInDown",
  },
  {
    href: "https://twitter.com/fxis_ai",
    src: "/images/SocialmediaIcons/X 2.webp",
    alt: "Twitter",
    animation: "fadeInUp",
  },
  {
    href: "mailto:contact@fxis.ai",
    src: "/images/SocialmediaIcons/Email 2.webp",
    alt: "Email",
    animation: "fadeInDown",
  },
];

const Footer = () => {
  const { t } = useTranslation();

  return (
    <section className="text-center p-0">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="footer-social">
              <ul className="list-unstyled">
                {socialLinks.map(({ href, src, alt, animation }, index) => (
                  <li key={index}>
                    <a
                      className={`wow ${animation}`}
                      href={href}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="social-icon"
                        src={src}
                        alt={alt}
                        loading="lazy"
                      />
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <Link to="/privacy-policy" className="footer-nav">
                {t("footer.privacypolicy")}
              </Link>
            </div>

            <p className="company-about fadeIn">
              &copy; {new Date().getFullYear()} {t("footer.rights")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
